// extracted by mini-css-extract-plugin
export default {"container":"juyn_2","button":"SHXBPR","actionsContainer":"JvXA2e","center":"KJPy_8","right":"NcXno_","top":"ovMwby","triangle":"OISqbJ","fixedColor":"Jv0dXX"};